import { Category } from '../../graphql/types';
import { BUILDING_TYPE_ID } from './constants';
import { checkIsFlatCategory, flatIds } from './common';

type BuildingType = { [key: string]: string };
export interface FilterOptions {
  data: {
    id: string;
    name: string;
  };
  name: string;
}

export const getDefaultTypeFilterOptions = (
  buildingType: BuildingType
): FilterOptions[] =>
  Object.entries(buildingType).map(([name, type]) => ({
    data: { id: type, name: `pages.current_item.categories.id_${type}` },
    name: `new-search-type-filter__${name.toLowerCase()}`
  }));

export const hasOneFlatCategory = (
  buildingTypes: Category[] | undefined = [],
  isPashaLanding: boolean | undefined
): boolean => {
  if (!buildingTypes?.length) return false;

  const countOfFlatCategories = buildingTypes.reduce((acc, curr) => {
    return (flatIds as string[]).includes(curr.id) ? acc + 1 : acc;
  }, 0);

  return countOfFlatCategories === 1 && !!isPashaLanding;
};

export const normalizeCategoryId = (
  id: string,
  hasPashaOneFlatCategory: boolean
): string =>
  hasPashaOneFlatCategory && checkIsFlatCategory(id)
    ? BUILDING_TYPE_ID.FLAT_ALL
    : id;

export const getTypeFilterOptions = (
  buildingTypes: Category[] = [],
  basedStat = 'new-search',
  isPashaLanding = false
): FilterOptions[] => {
  const hasPashaOneFlatCategory = hasOneFlatCategory(
    buildingTypes,
    isPashaLanding
  );

  const idToKey: Record<string, string> = Object.fromEntries(
    Object.entries(BUILDING_TYPE_ID).map(([k, v]) => [v, k.toLowerCase()])
  );

  return buildingTypes.map(cat => {
    const catId = normalizeCategoryId(cat.id, hasPashaOneFlatCategory);
    return {
      data: {
        id: cat.id,
        name: `pages.current_item.categories.id_${catId}`
      },
      name: `${basedStat}-type-filter__${idToKey[cat.id]}`
    };
  });
};
